import * as React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { withStyles, StyledComponentProps } from '@material-ui/core/styles';
import { styles } from '../../styles';
import { reservationSlot, reservation } from '../../../../model/reservation';
import moment from 'moment';
import { SearchBoxApi } from '../../../../ui-components/SearchBoxApi/SearchBoxApi';
import { contact } from '../../../../model/contact';
import { invokeApi } from '../../../../common/networking/invoker';

interface IProps extends StyledComponentProps {
    addInProgress: boolean;
    reservationToAdd: reservation;
    reservationSlot: reservationSlot;
    selectedUser?: contact;
    updateReservationToAdd: (reservation: reservation, selectedUser?: contact) => void;
}


const templateSearchBoxContact = (contact?: contact) => {
    return contact ? {
        label: (contact.surname ? contact.surname + " " + contact.name + " - " : "") + contact.email,
        value: contact
    } : undefined;
}

const searchContactsSearchBox = (search: string, take?: number): Promise<Array<contact>> => {
    return new Promise((resolve, reject) => {
        invokeApi({
            path: take ? `/api/Contacts?fullnameOrEmail=${search}&take=${take}`
                : `api/Contacts?fullnameOrEmail=${search}`,
            method: 'GET',
            responseType: "json",
        }).then(val => {
            resolve(val);
        }).catch(val => {
            reject(val)
        })
    })
}

const ReservationSlotAdd = (props: IProps) => {
    const classes = props.classes;
    // 
    let startTime = moment(props.reservationSlot.startingTime);
    let endTime = moment(props.reservationSlot.startingTime).add(props.reservationSlot.duration, "minute");
    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography className={classes.Typography}>Prenotazione:</Typography>
            </Grid>
            <Grid item xs={12} style={{ margin: "5px" }}>
                <SearchBoxApi<contact>
                    selectedItem={props.selectedUser}
                    openOnFocus
                    doFilter
                    disabled={props.addInProgress}
                    listSize={10}
                    getItems={searchContactsSearchBox}
                    label={"Utente"}
                    placeholder={"Digitare cognome o nome"}
                    templateItem={templateSearchBoxContact}
                    onSelectedChange={(item) => { props.updateReservationToAdd({ ...props.reservationToAdd, userId: item ? item.sub : "" }, item) }} />
            </Grid>
            <Grid item xs={6}>
                <Typography> Orario Entrata: {startTime.format("HH:mm")} - {endTime.format("HH:mm")}</Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography>Durata: {props.reservationSlot.stayingMinutes} minuti</Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography>Orario Effettivo: {startTime.format("HH:mm")} - {moment(startTime).add(props.reservationSlot.stayingMinutes, "minute").format("HH:mm")}</Typography>
            </Grid>
        </Grid>
    );

};
export default withStyles(styles as any)(ReservationSlotAdd)